import { useAppSelector } from "../../redux/hooks";
import { css } from "../../../styled-system/css";
import DismissibleBanner from "../core/basic/DismissibleBanner";
import { Link } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { VStack } from "../../../styled-system/jsx";
import { useAmazonAdsConnectionStatus } from "./onboarding/useAmazonAdsConnectionStatus";

export function LostAmazonAdvertisingProfileAccessBanner() {
  const { t } = useTranslation(["advertising"]);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const onboardData = useAppSelector((state) => state.amz_onboard);
  const user = useAppSelector((state) => state.user);

  const currentProfileConnectStatusQuery = useAmazonAdsConnectionStatus();

  if (
    channel !== "amazon" ||
    onboardData.amazon_advertising_access !== "connected" ||
    !currentProfileConnectStatusQuery.isSuccess ||
    currentProfileConnectStatusQuery.data.profile_has_amazon_ads_api_access ||
    !user.is_staff
  ) {
    return null;
  }

  const amazonAdsApiAuthUser = currentProfileConnectStatusQuery.data.amazon_ads_api_authorized_by;

  return (
    <DismissibleBanner
      storageKey={`dismiss_lost_profile_access_banner-${user.organization_id}`}
      dismissForDays={1}
      css={{ backgroundColor: "red.700", paddingY: "medium" }}
    >
      <VStack gap={0}>
        <p className={css({ color: "white", paddingX: "xsmall", fontSize: "medium" })}>
          {amazonAdsApiAuthUser ?
            <Trans
              t={t}
              i18nKey={($) =>
                $.advertising[
                  "We've lost Amazon Advertising API access to your current Amazon profile that was authorized by the Amazon user email <underline>{email}</underline>."
                ]
              }
              values={{ email: amazonAdsApiAuthUser }}
              components={{ underline: <span className={css({ textDecoration: "underline" })} /> }}
            />
          : t(($) => $.advertising["We've lost Amazon Advertising API access to your current Amazon profile."])}
        </p>
        <p className={css({ color: "white", paddingX: "xsmall", fontSize: "medium" })}>
          <Trans
            t={t}
            i18nKey={($) =>
              $.advertising[
                "Please have a user with campaign management access re-authorize on the <amazonConnectLink>Amazon Connect page</amazonConnectLink> or regain permissions on Amazon to ensure your campaigns continue to be managed by Trellis."
              ]
            }
            components={{
              amazonConnectLink: (
                <Link to="/user/amzsummary" className={css({ color: "white", paddingX: "xxsmall" })} />
              ),
            }}
          />
        </p>
      </VStack>
    </DismissibleBanner>
  );
}
